module.exports = __webpack_public_path__ + "static/media/icon-calendar.6c628c2a.svg";